import styled from 'styled-components/macro';
import { ContentStyled } from '@yme/atoms/accordion';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel3 } from '@yme/tokens/typography';
export const CookieContainerStyled = styled.div `
  padding: 24px 16px;
  background-color: ${colorCoreWhite1000};

  ${ADAPTIVE.minWidth.tablet} {
    padding: 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 48px;
  }

  ${ContentStyled} {
    ${({ isRightToLeft }) => (isRightToLeft ? 'padding-right' : 'padding-left')}: 24px;
  }
`;
export const DescriptionContainerStyled = styled.div `
  margin-bottom: 32px;
`;
export const TitleStyled = styled(HeadingLevel3) `
  margin-bottom: 16px;
`;
